import React from "react";
import { useForm } from "react-hook-form";
import {
  Grid,
  Button,
  ReactSelectController,
} from "@pushpress/shared-components";
import AppointmentTypeSelect from "../../../components/controllers/AppointmentTypeSelect";
import StaffSelect from "../../../components/controllers/StaffSelect";
import { AppointmentsFilterValue } from "./AppointmentCredits.types";
import { statusOptions } from "./AppointmentCredits.utils";
import { useFeatureFlag } from "../../../context/features";
import { RECURRING_APPT_FEATURE_FLAG } from "../../../context/features/features.utils";

interface AppointmentsFilterProps {
  filter: AppointmentsFilterValue;
  onFilterChange: (filter: AppointmentsFilterValue) => void;
  onClear: VoidFunction;
}

function AppointmentsFilter(props: AppointmentsFilterProps) {
  const { filter, onFilterChange, onClear } = props;

  const { isFeatureEnabled } = useFeatureFlag();

  const recurringBookingFlag = isFeatureEnabled(RECURRING_APPT_FEATURE_FLAG);

  const { control, handleSubmit } = useForm<AppointmentsFilterValue>({
    defaultValues: filter,
  });

  return (
    <form
      noValidate
      onSubmit={handleSubmit(onFilterChange)}
      style={{ padding: 20, width: 300 }}
    >
      <AppointmentTypeSelect
        isMulti
        label="Types"
        control={control}
        name="types"
        isClearable
        hideDropdownIndicator
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
      <StaffSelect
        isMulti
        label="Staff"
        control={control}
        name="staff"
        isClearable
        hideDropdownIndicator
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
      {recurringBookingFlag && (
        <ReactSelectController
          label="Status"
          control={control}
          name="status"
          isClearable
          isMulti
          hideDropdownIndicator
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          options={statusOptions}
          getOptionValue={(option) => option.label}
        />
      )}
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            text="Clear"
            buttonType="secondary"
            type="button"
            onClick={onClear}
          />
        </Grid>
        <Grid item>
          <Button text="Apply" buttonType="primary" type="submit" />
        </Grid>
      </Grid>
    </form>
  );
}

export default AppointmentsFilter;
